import './SlideIndicators.css';

interface SlideIndicatorsProps {
	totalSlides: number;
	currentSlide: number;
	onSlideChange: (index: number) => void;
}

const SlideIndicators = ({ totalSlides, currentSlide, onSlideChange }: SlideIndicatorsProps) => {
	return (
		<div className="slide-indicators-container">
			{Array.from({ length: totalSlides }).map((_, i) => (
				<button
					key={i}
					type="button"
					className={`indicator ${i === currentSlide ? 'selected' : ''}`}
					onClick={() => onSlideChange(i)}
					aria-label={`Go to slide ${i + 1}`}
					aria-current={i === currentSlide ? 'true' : undefined}
				/>
			))}
		</div>
	);
};

export default SlideIndicators;
